import { Component, Input, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';

import '@maersk-global/mds-components-core/mc-input';
import '@maersk-global/mds-components-core/mc-select';
import { ShopManagementService } from '../../../services/shop-management.service';
import { Currency } from '../../../models/currency.model';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-create-shops-financial-configuration',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './create-shops-financial-configuration.component.html',
  styleUrls: ['./create-shops-financial-configuration.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CreateShopsFinancialConfigurationComponent implements OnInit {
  @Input() formGroup!: FormGroup;

  // Link to Accounting options
  linkToAccountingOptions: string[] = ['RRIS', 'FACT', 'NO'];
  currencyList: Currency[] = [];
  isLoadingCurrencies: boolean = false;

  constructor(private shopManagementService: ShopManagementService) {}

  ngOnInit(): void {
    this.loadCurrencies();
  }

  async loadCurrencies(): Promise<void> {
    this.isLoadingCurrencies = true;
    try {
      const currencies = await firstValueFrom(this.shopManagementService.getCurrencies());
      this.currencyList = currencies;
    } catch (err) {
      console.error('Error loading currencies', err);
      this.currencyList = [];
    } finally {
      this.isLoadingCurrencies = false;
    }
  }

  isControlInErrorState(control: FormControl | any): boolean | null {
    if (control && control.invalid && control.touched) {
      return true;
    }
    return null;
  }
}
